import { Box } from '@chakra-ui/react'
import React from 'react'
import { GatsbyImage } from './elements/Image'

export const OverlayCard = ({ image, src, alt, sx, children }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        ...sx,
      }}
    >
      <GatsbyImage
        image={image}
        responsive={true}
        alt={alt}
        layout='fill'
        objectFit='cover'
      />

      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {children}
      </Box>
    </Box>
  )
}